module.exports = __webpack_public_path__ + "static/media/Illus-Congrats@3x.7afbb8d5.png";